"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrows = void 0;
var _react = _interopRequireDefault(require("react"));
var _Arrow = require("b2b-components/theme/components/Gallery/Arrow");
require("./Arrows.scss");
const Arrows = _ref => {
  let {
    top,
    slideIndex,
    maxSlideIndex,
    onSlideChange
  } = _ref;
  const handlePreviousSlideClick = () => slideIndex >= 1 && onSlideChange(slideIndex - 1);
  const handleNextSlideClick = () => slideIndex < maxSlideIndex && onSlideChange(slideIndex + 1);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonTableArrows",
    style: {
      top
    }
  }, /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
    className: "cds-ComparisonTableArrow cds-ComparisonTableArrow--Prev",
    isDisabled: slideIndex === 0,
    type: _Arrow.ARROW_TYPE.prev,
    onClick: handlePreviousSlideClick
  }), /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
    className: "cds-ComparisonTableArrow cds-ComparisonTableArrow--Next",
    isDisabled: slideIndex === maxSlideIndex,
    type: _Arrow.ARROW_TYPE.next,
    onClick: handleNextSlideClick
  }));
};
exports.Arrows = Arrows;
//# sourceMappingURL=Arrows.js.map